module.exports = __webpack_public_path__ + "static/media/arrows-dashboard@2x.08183943.jpg";